export default __webpack_public_path__ + "static/media/route.fe438f2c.svg";